module.exports = __webpack_public_path__ + "static/media/aws-screen.3c443d48.png";